import { HTTP } from '@/utils/http';
import Apis from '@/apis/index';
import Constants from '@/store/constants';
import store from '@/store/index'

const FilterToRule = {
  field: (filter) => {
    const source = filter.source ? filter.source.toLowerCase() : null;
    const fieldName = filter.fieldName.toLowerCase();
    console.log('fieldName', fieldName)
    console.log('source', source)
    for (let i = 0; i < Constants.fields.length; i++) {
      const field = Constants.fields[i];

      switch (true) {
        case /^artists|styles|tags|languages|boxes$/.test(field.name):
          if (source === field.name) return field;
          break;
        case /^sources/.test(field.name):
          if (fieldName === 'uid' && filter.include) return field;
          break;
        case /^exc-sources/.test(field.name):
          if (fieldName === 'uid' && !filter.include) return field;
          break;
        case /^targets$/.test(field.name):
          if (source === 'targets') return field;
          break;
        case /^position$/.test(field.name):
          if (source === 'charts' && fieldName==='position') return field;
          break;
        case /^weeks$/.test(field.name):
          if (source === 'charts' && fieldName==='weeks') return field;
          break;
        case /^country$/.test(field.name):
          if (source === 'charts' && fieldName==='countryid') return field;
          break;
        case /^categories$/.test(field.name):
          if (source === 'categories') return field;
          break;
        case /^artistName$/.test(field.name):
          if (fieldName === 'artist') return field;
          break;
        case /^labels$/.test(field.name):
          if (fieldName === 'labelid') return field;
          break;
        case /^gender$/.test(field.name):
          if (fieldName === 'genderid') return field;
          break;
        case /^instruments$/.test(field.name):
          if (fieldName === 'id' && source==='instruments') return field;
          break;
        case /^vocalInstruments$/.test(field.name):
          if (fieldName === 'id' && source==='vocalinstruments') return field;
          break;
        case /^type$/.test(field.name):
          if (fieldName === 'typeID') return field;
          break;
        //-------------------------------------------------------------------------------
        default:
          console.log('default')
          // title|year|bpm|mood|energy|isExplicit|duration|publicationDate
          if (fieldName === field.name.toLowerCase()) return field;
          break;
      }
    }
  },
  value: async (filter, name) => {
    const { values } = filter;
    switch (true) {
      default: return values;  // mood|energy|gender
      case /sources/.test(name):
        return store.state.stations && store.state.stations.items && values.map(uid => {
            const station = store.state.stations.items.find(station => station.uid === uid)
            if (station) {
                return station
            }

            return null
        }) || [];
      case /title|artistName|description/.test(name): return values.join(', ');
      case /artists/.test(name):
        const res = await HTTP.post(Apis.artists.search, {
          ids: values
        });
        return res.data.dataItem.items.map(item => {
          item.isVisible = true;
          return item;
        });
      case /tags|labels/.test(name):
        const items = [];
        var tagsResponse = await HTTP.get(`${Apis.parameters[name]}`);
        return tagsResponse.data.dataItem.filter(el => values.indexOf(el.id||el.code) >= 0)
        // for (let i = 0; i < values.length; i++) {
        //   const item = ?ids=${values[i]}`);
        //   item.data.dataItem.items && items.push(item.data.dataItem.items[0]);
        // }
        // return items;
      case /languages/.test(name):
        const languagesResponse = await HTTP.get(Apis.parameters[name]);
        return languagesResponse.data.dataItem.filter(el => values.indexOf(el.id||el.code) >= 0);
      case /styles/.test(name):
        const stylesResponse = await HTTP.get(Apis.parameters[name]);
        const styles = []
        stylesResponse.data.dataItem.map((style) => {
          styles.push(style)
          if (style.children.length) {
            style.children.map(child => styles.push(child))
          }
        })
        return styles.filter(el => values.indexOf(el.id||el.code) >= 0);
      case /duration/.test(name):
        console.log("--------------------------------------->",JSON.stringify(filter))
        if (filter.from && filter.to) {
          return filter.from !== filter.to ? { from: filter.from, to: filter.to } : filter.from;
        }
        return filter.from || filter.to;
      case /publicationDate/.test(name):
        console.log("publicationDate",JSON.stringify(filter), name)
        if (filter.from && filter.to) {
          let res = filter.from !== filter.to ? { from: new Date(filter.from), to:new Date(filter.to) } : new Date(filter.from);
          console.log("Values Publication Date",res)
          return res;
        }
        return new Date(filter.from || filter.to);
      case /year|bpm/.test(name):
        if (filter.values && filter.values.length) {
          return filter.values.join(', ')
        }
        if (filter.from && filter.to) {
          return filter.from !== filter.to ? { from: filter.from, to: filter.to } : filter.from;
        }
        return filter.from || filter.to;
      case /isExplicit/.test(name):
        return values[0];
     
    }
  },
  comparison: (filter, name) => {
    const operator = filter.operator ? filter.operator.toLowerCase() : null;

    switch (true) {
      case /artists|languages|styles|labels|tags|boxes|sources|targets|categories/.test(name):
        return filter.include ? 'include' : 'exclude';

      case /duration|publicationDate/.test(name):
        if (filter.to && filter.from) return filter.from === filter.to ? 'equals' : 'between';

        return filter.to ? 'lower' : 'greater';

      case /bpm|year/.test(name):
        if (filter.to && filter.from) return 'between'
        if (filter.to) return 'lower'
        if (filter.from) return 'greater'

        return 'equals'
      case /mood|energy|gender|type/.test(name):
        return 'equals';

      default:
        // title|artistName|isExplicit/
        return operator;
    }
  }
};

export default FilterToRule;


